import Cookies from 'js-cookie'

const TokenKey = process.env.VUE_APP_NODE_ENV + 'Admin-Token'
const UserKey = process.env.VUE_APP_NODE_ENV + 'userInfo'
const ThemeKey = process.env.VUE_APP_NODE_ENV + 'theme'
const languageKey = process.env.VUE_APP_NODE_ENV + 'language'
const guidFlag = process.env.VUE_APP_NODE_ENV + 'guidFlag'
const lastProjectKey = process.env.VUE_APP_NODE_ENV + "lastProjectInfo"
const lastProjectIdKey = process.env.VUE_APP_NODE_ENV + "lastProjectId"
const systemRoleKey = process.env.VUE_APP_NODE_ENV + "systemRole"
const factorInfoKey = process.env.VUE_APP_NODE_ENV + "factorInfo"
const domainListKey = process.env.VUE_APP_NODE_ENV + "domainList"
const currentDomainKey = process.env.VUE_APP_NODE_ENV + "currentDomain"
const showSpecialKey = process.env.VUE_APP_NODE_ENV + "showSpecialValue"

export function getToken() {
  return sessionStorage.getItem(TokenKey)
}

export function setToken(token) {
  sessionStorage.setItem(TokenKey, token || "")
}

export function removeToken() {
  sessionStorage.removeItem(TokenKey)
}

export function getUser() {
  return Cookies.get(UserKey)
}

export function getProjectinfo() {
  let userInfo = getUserInfo();

  let userId = userInfo.id
  let lastProjectId = window.sessionStorage.getItem(lastProjectIdKey + userId)
  return lastProjectId || userInfo.projectCurrent;
}

export function setSystemRole(systemRole) {
  window.sessionStorage.setItem(systemRoleKey, systemRole)
}
export function getSystemRole() {
  return window.sessionStorage.getItem(systemRoleKey) ? JSON.parse(window.sessionStorage.getItem(systemRoleKey)) : null;
}
export function getTheme() {
  return window.localStorage.getItem(ThemeKey) || 'light-theme'
}

export function setTheme(theme) {
  window.localStorage.setItem(ThemeKey, theme)
}
export function getLanguage() {
  let lan = navigator.systemLanguage || navigator.language;
  return window.localStorage.getItem(languageKey) || lan
}
export function setLanguage(language) {
  localStorage.setItem(languageKey, language)
}
export function setGuidance(userId, flag) {
  localStorage.setItem(guidFlag + userId, flag)
}
export function getGuidance(userId) {
  let flag = window.localStorage.getItem(guidFlag + userId) || 'true'
  return JSON.parse(flag)
}
export function getUserInfo() {
  return JSON.parse(sessionStorage.getItem(UserKey)) || {}
}
export function setUserInfo(userInfoStr) {
  // 设置lastProjectId
  let userInfo = JSON.parse(userInfoStr)
  if (userInfo) {
    if (userInfo.projectCurrent) {
      setLastProjectId(userInfo.id, userInfo.projectCurrent)
    }
  } else {
    userInfo = getUserInfo()
    setLastProjectId(userInfo.id, '')
  }
  sessionStorage.setItem(UserKey, userInfoStr)
}
export function getLastProjectId(userId) {
  let lastProjectId = window.sessionStorage.getItem(lastProjectIdKey + userId)
  return lastProjectId;
}
export function setLastProjectId(userId, projectId) {
  sessionStorage.setItem(lastProjectIdKey + userId, projectId)
}
export function setMagnification(value) {
  localStorage.setItem('magnification', value)
}
export function getMagnification() {
  return localStorage.getItem('magnification') || 60
}
export function getPointStatus(pointId, type, defaultVal) {
  let status = localStorage.getItem('showStatus_' + pointId)
  if (type == '1') {
    status = localStorage.getItem('showPointStatus_' + pointId)
  }
  return status || defaultVal || "hidden"
}
export function setPointStatus(pointId, status, type) {
  localStorage.setItem('showStatus_' + pointId, status)
  if (type == '1') {
    localStorage.setItem('showPointStatus_' + pointId, status)
  }
}
export function getLastProject(userId) {
  let projectInfo = window.sessionStorage.getItem(lastProjectKey + userId)
  return JSON.parse(projectInfo) || {}
}
export function setLastProject(userId, projectInfo) {
  sessionStorage.setItem(lastProjectKey + userId, JSON.stringify(projectInfo))
}
export function getFactorInfo() {
  let factor = sessionStorage.getItem(factorInfoKey)
  return JSON.parse(factor)
}
export function setFactorInfo(factorInfo) {
  sessionStorage.setItem(factorInfoKey, JSON.stringify(factorInfo))
}

export function getDomainList() {
  let list = sessionStorage.getItem(domainListKey)
  return JSON.parse(list)
}

export function setDomainList(list) {
  sessionStorage.setItem(domainListKey, JSON.stringify(list))
}

export function getCurrentDomain() {
  const currentdomain = sessionStorage.getItem(currentDomainKey)
  return currentdomain
}

export function setCurrentDomain(domain) {
  sessionStorage.setItem(currentDomainKey, domain)
}
export function setShowSpecialValue(key) {
  localStorage.setItem(showSpecialKey, key)
}
export function getShowSpecialValue() {
  let val = localStorage.getItem(showSpecialKey) || 'false'
  return JSON.parse(val)
}